import React, { useState } from 'react';
import { useTranslation } from 'react-i18next';
import './PromptDialog.css';

const PromptDialog = ({
  title,
  message,
  fields: fieldsProp,
  onSubmit,
  onCancel,
  submitText,
  cancelText
}) => {
  const { t } = useTranslation('common');
  const fields = fieldsProp || [{ name: 'value', label: t('promptDialog.value'), type: 'text', placeholder: '' }];
  const [values, setValues] = useState(
    fields.reduce((acc, field) => ({...acc, [field.name]: field.defaultValue || ''}), {})
  );

  const handleChange = (name, value) => {
    setValues(prev => ({ ...prev, [name]: value }));
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    if (onSubmit && typeof onSubmit === 'function') {
      const result = fields.length === 1 ? values[fields[0].name] : values;
      onSubmit(result);
    }
  };

  return (
    <div className="prompt-dialog-overlay" onClick={onCancel}>
      <div className="prompt-dialog" onClick={(e) => e.stopPropagation()}>
        <form onSubmit={handleSubmit}>
          <div className="prompt-dialog-header">
            <h3>{title ?? t('promptDialog.inputRequired')}</h3>
          </div>
          <div className="prompt-dialog-body">
            {message && <p className="prompt-dialog-message">{message}</p>}
            {fields.map((field) => (
              <div key={field.name} className="prompt-dialog-field">
                <label htmlFor={field.name}>{field.label}</label>
                {field.type === 'textarea' ? (
                  <textarea
                    id={field.name}
                    value={values[field.name]}
                    onChange={(e) => handleChange(field.name, e.target.value)}
                    placeholder={field.placeholder}
                    required={field.required !== false}
                    rows={field.rows || 3}
                    autoFocus={field.autofocus}
                  />
                ) : field.type === 'select' ? (
                  <select
                    id={field.name}
                    value={values[field.name]}
                    onChange={(e) => handleChange(field.name, e.target.value)}
                    required={field.required !== false}
                    autoFocus={field.autofocus}
                  >
                    <option value="" disabled hidden>{t('promptDialog.selectPlaceholder')}</option>
                    {field.options?.map(opt => (
                      <option key={opt.value} value={opt.value}>
                        {opt.label}
                      </option>
                    ))}
                  </select>
                ) : (
                  <input
                    id={field.name}
                    type={field.type || 'text'}
                    value={values[field.name]}
                    onChange={(e) => handleChange(field.name, e.target.value)}
                    placeholder={field.placeholder}
                    required={field.required !== false}
                    autoFocus={field.autofocus}
                  />
                )}
              </div>
            ))}
          </div>
          <div className="prompt-dialog-footer">
            <button
              type="button"
              className="btn btn-secondary"
              onClick={onCancel}
            >
              {cancelText ?? t('ui.cancel')}
            </button>
            <button
              type="submit"
              className="btn btn-primary"
            >
              {submitText ?? t('ui.submit')}
            </button>
          </div>
        </form>
      </div>
    </div>
  );
};

export default PromptDialog;
